import React from 'react';

interface IherbConfigProps {
  config: {
    stockLevel: number;
    batchSize: number;
    requestsPerSecond: number;
    handlingTimeOmd: number;
    providerSpecificHandlingTime: number;
    updateFlagValue: number;
    priceMarkupPercentage?: number; // Phase 2.1 - Markup % para cálculo de preço
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Componente de configuração específico para o fornecedor Iherb
 */
const IherbConfig: React.FC<IherbConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4">
      <div>
        <label htmlFor="stockLevel" className="block text-sm font-medium text-gray-700 mb-1">
          Nível de Estoque (Iherb)
        </label>
        <input
          id="stockLevel"
          type="number"
          name="stockLevel"
          value={config.stockLevel || ''}
          onChange={onChange}
          className="input"
          aria-label="Nível de estoque para Iherb"
        />
        <p className="text-sm text-gray-500 mt-1">
          Limite máximo de estoque a ser considerado para produtos do Iherb.
        </p>
      </div>

      <div>
        <label htmlFor="handlingTimeOmd" className="block text-sm font-medium text-gray-700 mb-1">
          Tempo de Manuseio OMD (dias)
        </label>
        <input
          id="handlingTimeOmd"
          type="number"
          name="handlingTimeOmd"
          value={config.handlingTimeOmd || ''}
          onChange={onChange}
          className="input"
          aria-label="Tempo de manuseio da OMD em dias"
        />
        <p className="text-sm text-gray-500 mt-1">
          Tempo de manuseio da OMD para produtos do Iherb.
        </p>
      </div>

      <div>
        <label htmlFor="iherbHandlingTime" className="block text-sm font-medium text-gray-700 mb-1">
          Tempo de Manuseio Iherb (dias)
        </label>
        <input
          id="iherbHandlingTime"
          type="number"
          name="providerSpecificHandlingTime"
          value={config.providerSpecificHandlingTime || ''}
          onChange={onChange}
          className="input"
          aria-label="Tempo de manuseio do Iherb em dias"
        />
        <p className="text-sm text-gray-500 mt-1">
          Tempo de manuseio específico do Iherb para seus produtos.
        </p>
      </div>

      <div>
        <label htmlFor="batchSize" className="block text-sm font-medium text-gray-700 mb-1">
          Tamanho do Lote
        </label>
        <input
          id="batchSize"
          type="number"
          name="batchSize"
          value={config.batchSize || ''}
          onChange={onChange}
          className="input"
          aria-label="Tamanho do lote"
        />
        <p className="text-sm text-gray-500 mt-1">
          Número de produtos a serem processados em cada lote durante o envio para a Amazon.
        </p>
      </div>

      <div>
        <label htmlFor="requestsPerSecond" className="block text-sm font-medium text-gray-700 mb-1">
          Requisições por Segundo
        </label>
        <input
          id="requestsPerSecond"
          type="number"
          name="requestsPerSecond"
          value={config.requestsPerSecond || ''}
          onChange={onChange}
          className="input"
          aria-label="Requisições por segundo"
        />
        <p className="text-sm text-gray-500 mt-1">
          Taxa de requisições à API do Iherb (limite para evitar bloqueio).
        </p>
      </div>

      <div>
        <label htmlFor="updateFlagValue" className="block text-sm font-medium text-gray-700 mb-1">
          Código de Atualização Iherb
        </label>
        <input
          id="updateFlagValue"
          type="number"
          name="updateFlagValue"
          value={config.updateFlagValue || ''}
          onChange={onChange}
          className="input"
          aria-label="Código de atualização Iherb"
        />
        <p className="text-sm text-gray-500 mt-1">
          Identificador usado para marcar produtos atualizados pelo Iherb no banco de dados.
        </p>
      </div>

      {/* Seção: Phase 2.1 - Price Markup */}
      <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-purple-900 mb-3">
          💰 Phase 2.1 - Price Markup
        </h3>

        <div>
          <label htmlFor="priceMarkupPercentage" className="block text-sm font-medium text-gray-700 mb-1">
            Markup Percentage (%)
          </label>
          <input
            id="priceMarkupPercentage"
            type="number"
            name="priceMarkupPercentage"
            min="0"
            step="0.1"
            value={config.priceMarkupPercentage || 15}
            onChange={onChange}
            className="input"
          />
          <p className="text-sm text-gray-500 mt-1">
            Percentual de markup aplicado ao calcular o preço Amazon.
          </p>
          <p className="text-sm text-purple-700 mt-2">
            <strong>ℹ️ Fórmula:</strong> Amazon Price = (supplier_price + shipping) × (1 + markup% / 100)
          </p>
          <p className="text-sm text-purple-700 mt-1">
            <strong>📝 Exemplo:</strong> Produto $10 + Shipping $5 com 15% markup = $17.25
          </p>
        </div>
      </div>
    </div>
  );
};

export default IherbConfig;
